import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import InfoPopup from '@/components/Popup/InfoPopup';
import appContent from '@/services/content/appContent';
import deviceStateService from '@/services/device/deviceStateService';
import mwConnectionService from '@/services/mw/mwConnectionService';
import mwStateService from '@/services/mw/mwStateService';
import productService from '@/services/product/productService';
import appRouterService from '@/services/route/appRouterService';
import {selectIsHolderRegistered} from '@/state/selectors/connectedProduct';
import {selectIsHolderConnected} from '@/state/selectors/mw';
import {hideLoader, showLoader} from '@/state/slices/loadersSlice';
import {hideModalAction, showDeviceRegistrationErrorModalAction} from '@/state/slices/modalSlice';

const HolderRegistrationPopup = ({modalType, isHolderReconnect}) => {
    const isHolderConnected = useSelector(selectIsHolderConnected);
    const isHolderRegistered = useSelector(selectIsHolderRegistered);
    const dispatch = useDispatch();
    const {icon, title, description, primaryButton, secondaryButton} = appContent.getHolderRegistrationPopup();

    const closePopup = () => {
        dispatch(hideModalAction(modalType));
    };

    const onClose = () => {
        closePopup();

        if (isHolderReconnect) {
            //if user close registration popup on holder reconnect then clear holder state
            mwStateService.clearHolderState();
        } else {
            deviceStateService.clearDeviceState();
            appRouterService.forwardToDevicesPage(true);
        }
    };

    useEffect(() => {
        if (!isHolderConnected && isHolderReconnect) {
            onClose();
        }
    }, [isHolderConnected]);

    useEffect(() => {
        if (isHolderRegistered) {
            closePopup();
        }
    }, [isHolderRegistered]);

    const handlePrimaryButtonClick = async () => {
        const onSuccess = () => {
            productService.registerConsumerProduct({
                isHolder: true,
                onError: (iccError) => {
                    dispatch(showDeviceRegistrationErrorModalAction({...iccError, isHolder: true, isHolderReconnect}));
                },
                onSuccess: () => {
                    // redirection is handled in useRegistration
                },
            });
        };

        if (isHolderReconnect) {
            // if holder reconnect then codentify already known
            // and popup will close automatically if isHolderConnected changed to false
            onSuccess();
        } else {
            dispatch(showLoader());
            await mwConnectionService.initHolderConnection({onSuccess});
            dispatch(hideLoader());
        }

        closePopup();
    };

    return (
        <InfoPopup
            className='ml:pt-20'
            onClose={onClose}
            title={title}
            description={description}
            primaryButton={{
                ariaLabel: primaryButton.alt,
                onClick: handlePrimaryButtonClick,
                text: primaryButton.text,
            }}
            secondaryButton={{
                ariaLabel: secondaryButton.alt,
                onClick: onClose,
                text: secondaryButton.text,
            }}
            icon={icon}
            isBlockerOverlay
            overlayClassName='z-[105]'
        />
    );
};

export default HolderRegistrationPopup;
